<template>
    <section
        class="faq"
        :class="{
            'faq--background': !content.style.background.turnOff.value,
        }"
    >
        <div class="faq__inner">
            <zoe-atom-text
                v-if="stringIsNotEmpty(content.text.value)"
                class="faq__text"
                :item="content.text.value"
            />

            <div class="faq__list">
                <article
                    v-for="(item, index) in content.items"
                    :key="index"
                    class="faq__tab"
                    :class="{
                        'faq__tab--background': !content.style.tab.turnOffBackground.value,
                        'faq__tab--closed': !openItems.includes(index),
                    }"
                    :data-faq-item="index + 1"
                    @click="toggleItem(index)"
                >
                    <div class="faq__tab-content">
                        <zoe-atom-text
                            v-if="stringIsNotEmpty(item.title.value)"
                            class="faq__tab-title"
                            :item="item.title.value"
                        />

                        <zoe-atom-text
                            v-if="stringIsNotEmpty(item.text.value)"
                            class="faq__tab-text"
                            :item="item.text.value"
                        />
                    </div>

                    <button class="faq__button faq__button--plus">
                        <span class="faq__icon" />
                    </button>

                    <button class="faq__button faq__button--min">
                        <span class="faq__icon" />
                    </button>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
import ZoeAtomText from '../../../../../../resources/components/atoms/text/v1.0.0/zoe-atom-text.vue';
import Component from '../../../../../../resources/mixins/component/component.vue';

export default {
    components: { ZoeAtomText },
    mixins: [ Component ],

    data() {
        return {
            openItems: [],
        };
    },

    methods: {
        toggleItem(index) {
            const item = document.querySelector(`[data-faq-item="${index + 1}"]`);
            const title = item.querySelector('.faq__tab-title');
            const text = item.querySelector('.faq__tab-text');

            if (this.openItems.includes(index)) {
                this.openItems = this.openItems.filter(item => item !== index);

                title.style.transitionDelay = null;
                text.style.maxHeight = '';
                text.style.opacity = 0;
            } else {
                this.openItems.push(index);

                const textHeight = text.scrollHeight;
                title.style.transitionDelay = '0s';
                text.style.maxHeight = textHeight + 'px';
                text.style.opacity = 1;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@use 'step-faq';

@layer step {
    .faq {
        --background: v-bind('content.style.background.color.value');
        --tab-background: v-bind('content.style.tab.backgroundColor.value');
        --tab-border-color: v-bind('content.style.tab.borderColor.value');
        --tab-icon-color: v-bind('content.style.tab.iconColor.value');
    }
}
</style>
